// extracted by mini-css-extract-plugin
export default {"pageWrap":"Tf-z","fullWidth":"Uf-z","heading":"Vf-z","fullBleed":"Wf-z","hidden":"Xf-z"};